import React from 'react'
import { FormProvider, useForm } from 'react-hook-form'
import { StyledQuickSignupForm } from './styled'
import { QuickSignupFormData } from './types'

export const QuickSignupForm: React.FC = () => {
  const methods = useForm<QuickSignupFormData>({
    defaultValues: {
      lastName: '',
      firstName: '',
      lastNameKana: '',
      firstNameKana: '',
      email: '',
    },
  })

  const onSubmit = (data: QuickSignupFormData) => {
    const params = new URLSearchParams({
      'user_registration_form[last_name]': data.lastName,
      'user_registration_form[first_name]': data.firstName,
      'user_registration_form[last_name_kana]': data.lastNameKana,
      'user_registration_form[first_name_kana]': data.firstNameKana,
      'user_registration_form[email]': data.email,
    }).toString()
    location.href = `/signup?${params}`
  }

  return (
    <FormProvider {...methods}>
      <form onSubmit={methods.handleSubmit(onSubmit)}>
        <StyledQuickSignupForm />
      </form>
    </FormProvider>
  )
}
